/**
 * Login Button Component
 */

import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../auth/authConfig';

export function LoginButton() {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <button
      onClick={handleLogin}
      className="w-full flex items-center justify-center gap-2 bg-primary-600 hover:bg-primary-700 text-white font-medium py-3 px-4 rounded-lg transition-colors"
    >
      <svg className="w-5 h-5" viewBox="0 0 21 21" fill="currentColor">
        <path d="M0 0h10v10H0V0zm11 0h10v10H11V0zM0 11h10v10H0V11zm11 0h10v10H11V11z" />
      </svg>
      Sign in with Microsoft
    </button>
  );
}
